// function to move menu on media query
  
(function ($, Drupal) {
    Drupal.behaviors.moveAnchorMenu = {
      attach(context) {
        const anchorMenu = once('moveAnchorMenu', '.landing-page-anchors', context);
        if ($(anchorMenu).is($('.landing-page-anchors'))) {
            anchorMenuElement = $(anchorMenu);
            console.log(anchorMenuElement);
            const minWidth = window.matchMedia('(min-width: 900px)');
            
            if (minWidth.matches) {
            if ((anchorMenuElement).hasClass('anchor-menu--top')) {
                anchorMenuElement.removeClass('anchor-menu--top');
                anchorMenuElement.prependTo($('#block-cas-home-landingpagetwocolumncontent'));
                
            }
            } else if (!anchorMenuElement.hasClass('anchor-menu--top')) {
                anchorMenuElement.addClass('anchor-menu--top');
                anchorMenuElement.appendTo($('#block-cas-home-precontent'));
            }
    
            $(window).resize(function () {
            if (minWidth.matches) {
                if (anchorMenuElement.hasClass('anchor-menu--top')) {
                    anchorMenuElement.removeClass('anchor-menu--top');
                    anchorMenuElement.prependTo($('#block-cas-home-landingpagetwocolumncontent'));
                }
                
            } else if (!(anchorMenuElement.hasClass('anchor-menu--top'))) {
                anchorMenuElement.addClass('anchor-menu--top');
                anchorMenuElement.appendTo($('#block-cas-home-precontent'));
            }
            });
        }
     }
    };

  })(jQuery, Drupal, once);